import { SelectedCourseType } from '@/pages/CourseSelectionActivity/type';
import { TimetableCourseType, TimetableType } from '@/types/timetable';
import { extractComparableCourseCode, isSameCourseCode } from '@/utils/course';
import { parseCourseScheduleRoom } from '@/utils/courseTime';

export const toTimetableCourse = (course: SelectedCourseType): TimetableCourseType => {
  return {
    id: undefined,
    category: course.category,
    subCategory: course.subCategory,
    field: course.field,
    code: course.code,
    name: course.name,
    professor: course.professor[0] ?? null,
    department: course.department,
    division: course.division,
    time: String(course.time),
    point: String(course.point),
    personeel: course.personeel,
    scheduleRoom: course.scheduleRoom,
    target: course.target,
    courseTimes: parseCourseScheduleRoom(course.scheduleRoom),
  };
};

export const mergeTimetableCourses = (
  base: TimetableType,
  additions: TimetableCourseType[],
  chapel?: null | TimetableCourseType,
): TimetableType => {
  const additionComparableCodes = new Set<string>([
    ...(chapel ? [extractComparableCourseCode(chapel.code)] : []),
    ...additions.map((course) => extractComparableCourseCode(course.code)),
  ]);

  const baseCourses = base.courses.filter(
    (course) => !additionComparableCodes.has(extractComparableCourseCode(course.code)),
  );

  const mergedAdditions = additions.filter(
    (course, index, arr) =>
      arr.findIndex((target) => isSameCourseCode(target.code, course.code)) === index,
  );

  return {
    ...base,
    courses: [...baseCourses, ...mergedAdditions, ...(chapel ? [chapel] : [])],
  };
};
